import { UserBadge } from "../common/UserBadge"
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import DoneIcon from '@mui/icons-material/Done';
import { format } from 'date-fns';
import formatTimeAgo from "../hooks/formatTimeAgo";
import { useAppSelector } from "../../store/hooks";
import formatLimitedText from "../hooks/formatLimitedText";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ArchiveIcon from '@mui/icons-material/Archive';

export const ChatListCardSkeleton: React.FC = () => {

    return (
        <div className="flex flex-col w-full gap-1">
            <div className={`group relative flex flex-row gap-2 w-full shadow-main rounded-xl p-2 cursor-pointer hover:bg-primary_light transition-all duration-300`}>

                <div className="skeleton_shine w-12 h-12 rounded-full">
                </div>
                <div className="flex flex-col gap-1">
                    <div className="flex flex-row justify-between">
                        <div className="flex flex-row items-center">
                            <div className="skeleton_shine h-4 w-10 rounded-xl"></div>
                        </div>


                    </div>

                    <div className="flex flex-row gap-2">
                        <div className="skeleton_shine h-3 w-[50px] rounded-xl"></div>
                        <div className="skeleton_shine h-3 w-[30px] rounded-xl"></div>
                    </div>
                </div>

            </div>

        </div>
    )
}

